import React, { useEffect, useState } from "react";
import MuiHeader from "../../components/MuiHeader";
import api from "../../api/api";
import {
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
} from "@mui/material";
import moment from "moment";

const AmazonVoucherStatus = () => {
  const monthArr = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const currentYear = new Date().getFullYear();
  const currentMonth = moment().format("MMMM");
  const currentMonthSelected = monthArr.find(
    (item) => item.label === currentMonth
  );

  const [userdata, setUserdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [submitPressed, setSubmitPressed] = useState(false);

  useEffect(() => {
    // Dynamically calculate the years (current year and previous 3 years)
    const dynamicYears = Array.from({ length: 4 }, (_, i) => currentYear - i);
    setYears(dynamicYears);
  }, []);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleSelectedMonth = (e) => {
    const selectedMonth = e.target.value;

    if (
      selectedYear === currentYear &&
      selectedMonth > currentMonthSelected.value
    ) {
      alert("You can't select a month greater than the current month!");
    } else {
      setSelectedMonth(selectedMonth);
    }
  };

  const handleSubmit = async () => {
    if (selectedYear && selectedMonth) {
      setLoading(true);

      try {
        const res = await api.get(
          `getRewardCouponsReport/${selectedMonth}/${selectedYear}`
        );
        setTimeout(() => {
          setLoading(false);
          setUserdata(res.data || []);
          setSubmitPressed(true);
        }, 1000);
      } catch (error) {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        setUserdata([]);
        setSubmitPressed(true);
      }
    } else {
      alert("Select both month and year!");
    }
  };

  return (
    <>
      <MuiHeader header="Amazon Voucher Status" />

      <div style={{ display: "flex", marginLeft: "100px" }}>
        <Grid item>
          <FormControl
            sx={{ m: 1 }}
            style={{ width: "130px", marginLeft: "-64px" }}
            size="small"
          >
            <InputLabel id="year-select-label">Year</InputLabel>
            <Select
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
            >
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
            <InputLabel id="month-select-label">Month</InputLabel>
            <Select
              labelId="month-select-label"
              id="month-select"
              value={selectedMonth}
              onChange={handleSelectedMonth}
            >
              {monthArr.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          style={{ marginRight: "20px", height: "30%", marginTop: "8px" }}
        >
          Submit
        </Button>
      </div>

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      ) : userdata.length > 0 ? (
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {userdata.map((eachdata, index) => (
              <Grid item xs={2} sm={4} md={4} key={index}>
                <Card sx={{ minWidth: 275 }} style={{ cursor: "pointer" }}>
                  <CardContent>
                    <Typography sx={{ fontSize: 16 }} gutterBottom>
                      {eachdata.username}
                    </Typography>
                    <Typography sx={{ fontSize: 12, mb: 1.5 }}>
                      {eachdata.managername}
                      <br />
                      {eachdata.passcode}
                    </Typography>
                    <Typography variant="body2">
                      Coin used: {eachdata.coinsUsed}
                    </Typography>
                    <Typography variant="body2">
                      Coupon Code: {eachdata.couponCode}
                    </Typography>
                    <Typography variant="body2">
                      Redeemed On:{" "}
                      {moment(eachdata.redeemedOn).format("DD/MM/YY")}
                    </Typography>
                    <Typography variant="body2">
                      Amount: {eachdata.amount}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : submitPressed && userdata.length === 0 ? (
        <h1 style={{ textAlign: "center" }}>No data available</h1>
      ) : null}
    </>
  );
};

export default AmazonVoucherStatus;
